"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBasisTheoryValue = void 0;
var _core = require("../core");
/**
 * Resolves which BasisTheoryReact instance to use,
 * by favoring the optional parameter.
 * For internal use only.
 * @param bt
 * @returns parameter if it exists; instance from Context otherwise
 */
const useBasisTheoryValue = bt => {
  const {
    bt: btFromContext
  } = (0, _core.useBasisTheory)();
  return bt || btFromContext;
};
exports.useBasisTheoryValue = useBasisTheoryValue;